/**
 * @flow
 * @format
 */

import _TableGroup from './TableGroup';

export default _TableGroup;



// WEBPACK FOOTER //
// ./src/components/TableGroup/index.js